<template>
    <div class="publish-widget">
        <lang-selector v-model="selectedLang" @addNewLang="addNewLang" :lang-list="langList"/>
        <div id="widget-offline" class="widget-section">
            <h3 class="primary-text text-bold ">Widget Offline/Closed</h3>

            <div class="publish-input-body">
                <v-layout row wrap>
                    <v-flex xs4>
                        <label class="d-block">Bubble icon open</label>
                        <image-input  :small="true" :url="widgetParameters[selectedLang].openBubbleImage" @onImageUpload="widgetParameters[selectedLang].openBubbleImage = $event "></image-input>
                    </v-flex>
                    <v-flex xs4>
                        <label class="d-block">Bubble Icon close</label>
                        <image-input  :small="true" :url="widgetParameters[selectedLang].closeBubbleImage" @onImageUpload="widgetParameters[selectedLang].closeBubbleImage = $event "></image-input>
                    </v-flex>
                    <v-flex xs4>
                        <label class="">Bubble background color</label>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].bubbleButtonColor" />
                            </span>
                            </template>
                            <span>Open chat button background color</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4>
                        <label class=" d-block">Bubble icon type</label>
                        <v-radio-group v-model="widgetParameters[selectedLang].openBubbleImageColorType" row color="primary">
                            <v-radio
                              label="White"
                              value="white"
                              color="primary"
                            ></v-radio>
                            <v-radio
                              label="Colored"
                              color="primary"
                              value="colored"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>


                    <v-flex xs4>
                        <label for="">Bubble icon full width</label>
                        <v-switch v-model="widgetParameters[selectedLang].openBubbleImageFullWidth"/>
                    </v-flex>

                    <v-flex xs4>
                        <label class="">Widget Position</label>
                        <v-radio-group v-model="widgetParameters[selectedLang].position" row color="primary">
                            <v-radio
                                    label="Left"
                                    value="left"
                                    color="primary"
                            ></v-radio>
                            <v-radio
                                    label="Right"
                                    color="primary"
                                    value="right"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>

                    <v-flex xs12 />

                    <v-flex xs4f>
                        <label class="">Offline message</label>
                        <v-textarea
                          class=""
                          v-model="widgetParameters[selectedLang].offlineMessage"
                          outline
                        ></v-textarea>
                    </v-flex>
                    <v-flex xs4>
                        <label for="">Offline message appearance</label>
                        <v-radio-group v-model="widgetParameters[selectedLang].offLineMessageAppearance"  color="primary">
                            <v-radio
                                    v-for="appearance in offLineMessageAppearanceList"
                                    :label="appearance.name"
                                    :value="appearance.value"
                                    color="primary"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs4>
                        <label class="">Offline message colors</label>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].offLineMessageBackgroundColor" />
                            </span>

                            </template>
                            <span>Offline message background color</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].offLineMessageFontColor" />
                            </span>

                            </template>
                            <span>Offline message font color</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4>
                        <label>WhatsApp link</label>
                        <v-text-field
                          class=""
                          v-model="widgetParameters[selectedLang].whatsAppChatButtonLink"
                          outline
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <label for="">WhatsApp display option</label>
                        <v-switch label="Display only WhatsApp widget" v-model="widgetParameters[selectedLang].whatsAppMandatory" color="primary" class="d-block hide-messages"></v-switch>
                    </v-flex>

                    <v-flex xs4 v-if="widgetParameters[selectedLang].whatsAppChatButtonLink">
                        <label class="">Channels buttons color</label>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].whatsAppBtnColor" />
                            </span>

                            </template>
                            <span>WhatsApp button background color</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="!widgetParameters[selectedLang].whatsAppMandatory">
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].webBtnColor" />
                            </span>

                            </template>
                            <span>Web button background color</span>
                        </v-tooltip>
                    </v-flex>

                    <v-flex xs4 v-if="widgetParameters[selectedLang].whatsAppChatButtonLink">
                        <label class="d-block">WhatsApp icon</label>
                        <image-input  :small="true" :url="widgetParameters[selectedLang].whatsAppBtnImg" @onImageUpload="widgetParameters[selectedLang].whatsAppBtnImg = $event "></image-input>
                    </v-flex>

                    <v-flex xs4 v-if="!widgetParameters[selectedLang].whatsAppMandatory && widgetParameters[selectedLang].whatsAppChatButtonLink">
                        <label class="d-block">Web icon</label>
                        <image-input  :small="true" :url="widgetParameters[selectedLang].webBtnImg" @onImageUpload="widgetParameters[selectedLang].webBtnImg = $event "></image-input>
                    </v-flex>


                </v-layout>
            </div>
        </div>

        <hr>

        <div id="widget-intro" class="widget-section">
            <h3 class="primary-text text-bold ">Widget Intro</h3>

            <div class="publish-input-body">
                <v-layout row wrap>

                    <v-flex xs4>
                        <label class="">Logo</label>
                        <image-input  :small="true" :url="widgetParameters[selectedLang].logo" @onImageUpload="widgetParameters[selectedLang].logo = $event "></image-input>
                    </v-flex>

                    <v-flex xs4>
                        <label class=" d-block">Logo color type</label>
                        <v-radio-group v-model="widgetParameters[selectedLang].logoColorType" row color="primary">
                            <v-radio
                              label="White"
                              value="white"
                              color="primary"
                            ></v-radio>
                            <v-radio
                              label="Colored"
                              color="primary"
                              value="colored"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>

                    <v-flex xs4>
                        <label class="">Intro colors</label>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].mainColor" />
                            </span>

                            </template>
                            <span>Actions color</span>
                        </v-tooltip>


                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].headerColor" />
                            </span>

                            </template>
                            <span>Header background color</span>
                        </v-tooltip>


                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].headerFontColor" />
                            </span>

                            </template>
                            <span>Header font color</span>
                        </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].introButtonsColor" />
                            </span>

                        </template>
                        <span>Intro buttons font color</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].introButtonsBackground" />
                            </span>

                        </template>
                        <span>Intro buttons background color</span>
                      </v-tooltip>


                    </v-flex>




                    <v-flex xs6>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <label class="  d-block">Header</label>
                            <v-textarea
                              class=""
                              v-model="widgetParameters[selectedLang].header"
                              outline
                            ></v-textarea>
                        </div>
                    </v-flex>
                    <v-flex xs6>
                        <label class="">Sub Header</label>
                        <v-textarea
                          class=""
                          v-model="widgetParameters[selectedLang].subHeader"
                          outline
                        ></v-textarea>
                    </v-flex>





                            <v-flex xs4>
                                <label >Start button label</label>
                                <v-text-field
                                  class=""
                                  v-model="widgetParameters[selectedLang].startButtonLabel"
                                  outline
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <label for="">Language </label>
                                <v-autocomplete
                                  v-model="widgetParameters[selectedLang].lang"
                                  :items="langIso"
                                  item-text="name"
                                  class=""
                                  item-value="code"
                                  outline
                                  solo
                                  label="Search Languages"
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs4 class="pt-5">
                                <v-switch label="Hide forms" v-model="widgetParameters[selectedLang].hideForms" color="primary" class="d-block hide-messages"></v-switch>
                                <v-switch v-model="widgetParameters[selectedLang].hideFaqs" label="Hide FAQs" color="primary" class="d-block hide-messages"></v-switch>
                                <v-switch v-model="widgetParameters[selectedLang].displayIntroButtons" label="Display intro buttons" color="primary" class="d-block hide-messages"></v-switch>
                            </v-flex>


                    <v-flex xs4>
                        <label class="">FAQs title</label>
                        <v-text-field
                          class=""
                          v-model="widgetParameters[selectedLang].faqsTitle"
                          outline
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs4>
                        <label class="">FAQs title</label>
                        <v-text-field
                          class=""
                          v-model="widgetParameters[selectedLang].faqsPlaceholder"
                          outline
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs4></v-flex>


                    <v-flex xs4>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <label>Messenger link</label>
                            <v-text-field
                              class=""
                              v-model="widgetParameters[selectedLang].facebookLink"
                              outline
                            ></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <label>Whatsapp link</label>
                        <v-text-field
                          class=""
                          v-model="widgetParameters[selectedLang].whatsappLink"
                          outline
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs4>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <label>Twitter link</label>
                            <v-text-field
                              class=""
                              v-model="widgetParameters[selectedLang].twitterLink"
                              outline
                            ></v-text-field>
                        </div>
                    </v-flex>





                </v-layout>
            </div>
        </div>

        <hr>

        <div id="widget-chat" class="widget-section">
            <h3 class="primary-text text-bold ">Widget Chat</h3>

            <div class="publish-input-body">
                <v-layout row wrap>


                    <v-flex xs4>
                        <label> Font</label>
                        <v-autocomplete
                          :items="googleFonts"
                          item-value="family"
                          item-text="family"
                          v-model="widgetParameters[selectedLang].font"
                          solo
                          outline
                        ></v-autocomplete>
                    </v-flex>

                    <v-flex xs4>
                        <label>Font Size</label>
                        <v-select
                          v-model="widgetParameters[selectedLang].fontSize"
                          :items="[11,12,13,14,15,16]"
                          type="number"
                          outline
                        ></v-select>
                    </v-flex>

                    <v-flex xs4>
                        <label class="">Text bubbles colors</label>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].userSideColor" />
                            </span>

                            </template>
                            <span>User text background color</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].userSideFontColor" />
                            </span>

                            </template>
                            <span>User text color</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].chatBotAnswerColor" />
                            </span>

                            </template>
                            <span>Bot text background color</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].chatBotAnswerFontColor" />
                            </span>

                            </template>
                            <span>Bot text color</span>
                        </v-tooltip>


                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].buttonsColor" />
                            </span>

                            </template>
                            <span>Buttons font color</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].buttonsBackgroundColor" />
                            </span>

                            </template>
                            <span>Buttons background color</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].buttonsBorderColor" />
                            </span>

                            </template>
                            <span>Buttons border color</span>
                        </v-tooltip>

                    </v-flex>

                    <v-flex xs12 >
                        <label for="" class="mt-4">Chat bubble shape</label>
                        <v-btn-toggle v-model="widgetParameters[selectedLang].chatBubble" class="chat-bubbles">
                            <v-btn
                              v-for="btn in chatBubbleOptions"
                              :class="btn.class"
                              :value="btn.value"
                            >
                                {{btn.name}}
                            </v-btn>
                        </v-btn-toggle>
                    </v-flex>

                    <v-flex xs4>
                        <label class=" d-block">Avatar logo</label>
                        <image-input  :small="true" :url="widgetParameters[selectedLang].botAvatar" @onImageUpload="widgetParameters[selectedLang].botAvatar = $event "></image-input>
                    </v-flex>

                    <v-flex xs4>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <label>Avatar name</label>
                            <v-text-field
                              class=""
                              v-model="widgetParameters[selectedLang].botName"
                              outline
                            ></v-text-field>
                        </div>
                    </v-flex>

                    <v-flex xs4>
                        <label for="">Avatar full width</label>
                        <v-switch v-model="widgetParameters[selectedLang].botAvatarHasFullWidth"/>
                    </v-flex>



                    <v-flex xs4>
                        <label class=" d-block">Avatar logo type</label>
                        <v-radio-group v-model="widgetParameters[selectedLang].botAvatarColorType" row color="primary">
                            <v-radio
                              label="White"
                              value="white"
                              color="primary"
                            ></v-radio>
                            <v-radio
                              label="Colored"
                              color="primary"
                              value="colored"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>

                    <v-flex xs4>
                        <label class=" d-block">Avatar background type</label>
                        <v-radio-group v-model="widgetParameters[selectedLang].avatarType" row color="primary">
                            <v-radio
                              label="Rounded"
                              value="circle"
                              color="primary"
                            ></v-radio>
                            <v-radio
                              label="Transparent"
                              color="primary"
                              value="square"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>


                    <v-flex xs4>
                        <label class="  d-block">Avatar background</label>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <swatches show-fallback
                                        class="inline-block "
                                        row-length="5.5"
                                        shapes="circles"
                                        show-border
                                        popover-x="left"
                                        v-model="widgetParameters[selectedLang].avatarBackgroundColor" />
                            </span>

                            </template>
                            <span>Avatar background</span>
                        </v-tooltip>
                    </v-flex>



                    <v-flex xs4>
                        <label class="d-block">Agent default avatar</label>
                        <image-input  :small="true" :url="widgetParameters[selectedLang].agentDefaultAvatar" @onImageUpload="widgetParameters[selectedLang].agentDefaultAvatar = $event "></image-input>
                    </v-flex>


                    <v-flex xs4>
                        <label class="">User chat placeholder</label>
                        <v-text-field
                          class=""
                          v-model="widgetParameters[selectedLang].inputPlaceHolder"
                          outline
                        ></v-text-field>
                    </v-flex>


                    <v-flex xs4>
                    </v-flex>

                    <v-flex xs4>
                        <label class="d-block">Show location sharing</label>
                        <v-switch v-model="widgetParameters[selectedLang].showLocationLocator" label="Show Location locator" color="primary" class="d-block hide-messages"></v-switch>
                    </v-flex>



                    <v-flex xs4 v-if="widgetParameters[selectedLang].showLocationLocator">
                        <label class="">Google maps API key</label>
                        <v-text-field
                          class=""
                          v-model="widgetParameters[selectedLang].googleMapApiKey"
                          outline
                        ></v-text-field>
                    </v-flex>



                    <v-flex xs4>
                        <label class="d-block">Prevent buttons multiple click</label>
                        <v-switch v-model="widgetParameters[selectedLang].buttonsSingleClick" label="Prevent user to click multiple times on hero and gallery card buttons" color="primary" class="d-block hide-messages"></v-switch>
                    </v-flex>

                    <v-flex xs6>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <label class="">Message Notification Sound URL</label>
                            <v-text-field
                              class=""
                              v-model="widgetParameters[selectedLang].messageSound"
                              outline
                            ></v-text-field>
                            <image-input
                              :url="widgetParameters[selectedLang].messageSound"
                              @onImageUpload="widgetParameters[selectedLang].messageSound = $event"
                              type="audio"
                              icon="botter-audio-icon"
                            />
                        </div>
                    </v-flex>
                    <v-flex xs6>
                        <label class="">Typing Notification Sound URL</label>
                        <v-text-field
                          class=""
                          v-model="widgetParameters[selectedLang].typingSound"
                          outline
                        ></v-text-field>
                        <image-input
                          :url="widgetParameters[selectedLang].typingSound"
                          @onImageUpload="widgetParameters[selectedLang].typingSound = $event"
                          type="audio"
                          icon="botter-audio-icon"
                        />
                    </v-flex>




                </v-layout>
            </div>
        </div>

        <hr>

        <div id="#widget-demo" class="widget-section">
            <h3 class="primary-text text-bold ">Demo Parameters</h3>
            <div class="publish-input-body">
                <v-layout>
                    <v-flex xs6 >
                        <label class=" d-block">Demo background</label>
                        <image-input :validation="false" :can-remove="true" :url="widgetParameters[selectedLang].demoBackground" @onImageUpload="widgetParameters[selectedLang].demoBackground = $event"></image-input>
                    </v-flex>
                </v-layout>
            </div>
        </div>

        <div class="text-left mt-5">
            <a @click="publishWidget"   class="v-btn  v-btn v-btn--large v-btn--round  theme--light primary">Publish And Generate Widget</a>
            <a @click="createDemoLink" target="_blank" class="v-btn  v-btn v-btn--large v-btn--round  theme--light primary">Get Demo Link</a>
        </div>


        <v-tabs
          v-if="generated_widget_card"
          v-model="activeTab"
          color="white"
          id="generated_widget_card"
          light
          class="widget-code"
          slider-color="gray"
          right
        >
            <v-tab href="#tab-2">
                Iframe
            </v-tab>
            <v-tab-item
                value="tab-2"
                class=""
            >
                <p>{{genratedIframe}}</p>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import vueDropzone from 'vue2-dropzone'
    import Swatches from 'vue-swatches'
    import colorPicker from "../common/colorPicker";
    import common from "../../utils/common";
    import imageInput from '../block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone'
    import ColorPicker from "../common/colorPicker";
    import langIso from "../../utils/lang-iso"
    import langSelector from "./langSelector";
    import _ from 'lodash'
    export default {
        name: "designForm",
        components: {
            ColorPicker,
            vueDropzone,
            Swatches,
            imageInput,
            langSelector
        },
        data () {
            return {
                langIso,
                langList: [],
                activeTab: 0,
                selectedLang: 'en_US',
                offLineMessageAppearanceList: [
                    {
                        name: 'Off',
                        value: 'off',
                    },
                    {
                        name: 'Appear once',
                        value: 'once',
                    },
                    {
                        name: 'Appear every-time',
                        value: 'every-time'
                    }
                ],
                chatBubbleOptions: [
                    {
                        name: 'Solid',
                        value: 'solid',
                        class: 'btn btn-solid'
                    },
                    {
                        name: 'Rounded',
                        value: 'rounded',
                        class: 'btn btn-rounded active'
                    },
                    {
                        name: 'Curvey',
                        value: 'curvey',
                        class: 'btn btn-curvey'
                    }
                ],
                generated_widget_card: false,
                googleFonts: [],
                generatedWidget: '',
                generatedWidgetSaved: '',
                genratedIframe: '',
                generatedWidgetAndroid: '',
                generatedWidgetIOS: '',
                settings: {},
                widgetParameters: {
                    en_US: {
                        header:"Chat with botter",
                        subHeader:"We’re here to answer your questions about Company. Ask us anything!",
                        offlineMessage: "We’re here to answer your questions about Company. Ask us anything!",
                        botName: "BOTTER",
                        startButtonLabel : "Start now",
                        inputPlaceHolder : "Write a reply",
                        mainColor: '#473FB3',
                        userSideColor:"#473FB3",
                        userSideFontColor: "white",
                        headerColor:"#473FB3",
                        headerFontColor:"white",
                        chatBotAnswerColor:"#eaf0f7",
                        chatBotAnswerFontColor:"#000",
                        bubbleButtonColor: "#473FB3",
                        avatarBackgroundColor: "#eee",
                        buttonsColor: '#473FB3',
                        buttonsBackgroundColor: '#fff',
                        buttonsBorderColor: '#473FB3',
                        typingSound: '',
                        messageSound: '',
                        logo: "https://dashboard.botter.live/img/logo.8878de79.png",
                        botAvatar: "https://dashboard.botter.live/img/logo.8878de79.png",
                        agentDefaultAvatar: "https://prod-api.botter.live/uploads/2020-08-10/1597053363.png",
                        openBubbleImage:"https://dashboard.botter.live/img/logo.8878de79.png",
                        closeBubbleImage: "https://api.botter.live/uploads/2020-07-24/1595585747.png",
                        logoColorType: "white",
                        botAvatarColorType: "colored",
                        botAvatarHasFullWidth: false,
                        openBubbleImageColorType: "white",
                        openBubbleImageFullWidth: false,
                        offLineMessageBackgroundColor: "#fff",
                        offLineMessageFontColor: '#000',
                        offLineMessageAppearance: 'once',
                        avatarType: "circle",
                        font:"Roboto",
                        fontSize: 14,
                        chatBubble:"curvey",
                        direction: 'ltr',
                        position: 'right',
                        hideFaqs: false,
                        hideForms: false,
                        displayIntroButtons: false,
                        rememberUser: true,
                        facebookLink: "",
                        twitterLink: "",
                        whatsappLink: "",
                        demoBackground: '',
                        showLocationLocator: false,
                        googleMapApiKey: '',
                        buttonsSingleClick: false,
                        whatsAppChatButtonLink: '',
                        whatsAppMandatory: false,
                        whatsAppBtnColor: '#01AF9C',
                        webBtnColor: '#FFC108',
                        whatsAppBtnImg: 'https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/whatsapp.png',
                        webBtnImg: 'https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/web.png',
                        faqsTitle: 'Find an answer your self',
                        faqsPlaceholder: 'Search FAQs',
                        introButtonsBackground: "#fff",
                        introButtonsColor: '#000'
                    }
                }
            }
        },
        beforeMount() {

        },
        mounted() {

            this.getWidgetSettings()
            this.getGoogleFonts()
            this.getSettings()
        },
        methods: {
            getGoogleFonts(){
                this.$http_without_base.get('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBr6nsPTXn2O1RTMMt4OTaY9ofFh6QEgWs')
                    .then(response=>{
                        this.googleFonts = response.data.items
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
            addNewLang(lang) {
                this.widgetParameters[lang.code]= _.cloneDeep(this.widgetParameters.en_US)
            },
            getSettings() {
                this.$http_bot.get('/settings/')
                    .then(response=>{
                        this.settings = response.data
                    })
                    .catch(error=>{
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    })
            },
            saveWidgetSettings () {
                this.$http_session_manager.put(`bots/${this.$store.state.bot.botId}/widget-settings`,this.widgetParameters)
                .then(response=>{

                })
                  .catch(error=>{
                      if (error.response.status === 401) {
                          common.logOut()
                      }
                  })
            },
            getWidgetSettings () {
                this.$store.dispatch('setLoader', true)
                this.$http_session_manager.get(`bots/${this.$store.state.bot.botId}/widget-settings?all=true`)
                .then(response=>{
                    if (response.data && response.data.data) {

                        for (let lang in response.data.data) {
                            if (response.data.data.hasOwnProperty(lang)) {
                                let langObj = this.langIso.find((itemLang)=>{
                                    return itemLang.code === lang
                                })
                                if (langObj) {
                                    this.langList.push(langObj)
                                }
                            }
                        }

                        setTimeout(()=>{
                            this.widgetParameters = response.data.data
                            this.fillMissingData()
                        },3000)

                    } else {
                        this.langList.push({ "code": "en_US", "name": "English" })
                    }
                    setTimeout(()=>{
                        this.$store.dispatch('setLoader', false)
                    },3000)
                })
                  .catch(error=>{
                      this.$store.dispatch('setLoader', false)
                      if (error.response.status === 401) {
                          common.logOut()
                      }

                  })
            },
            createDemoLink() {
                this.saveWidgetSettings()
                let queryUrl = `bot_id=${this.botId}&&botterLang=${this.selectedLang}`
                window.open(`${this.widgetUrl}/?${queryUrl}`,'_blank' )
            },
            publishWidget(){
                this.saveWidgetSettings()
                let widgetParameters = JSON.stringify(this.widgetParameters[this.selectedLang])
                let widgetJsFile = '<script src="'+process.env.VUE_APP_WIDGET_IFRAME_URL+'/app.js"></scr'+'ipt>'
                let iframeJsFile = '<script src="'+process.env.VUE_APP_WIDGET_IFRAME_URL+'/iframe/script.js"></scr'+'ipt>'
                this.generatedWidget = `
                    <div id="botter-widget"
                        widget_parameters='${widgetParameters}'
                        bing-subscription-key="ca86942144d34294a7dfd3afddd8dd50"
                        bot_id="${this.botId}"
                        locale="${this.selectedLang}" >
                         <div id=botter-widget-app></div>
                         <link rel=stylesheet href=https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css>
                    </div>
                    ${widgetJsFile}
                `
                this.generatedWidgetSaved = `
                       <div id="botter-widget"
                        bot_id="${this.botId}"
                        locale="${this.selectedLang}" >
                         <div id=botter-widget-app></div>
                         <link rel=stylesheet href=https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css>
                    </div>
                    ${widgetJsFile}
                `
                this.genratedIframe = `
                    <link rel="stylesheet" type="text/css" href="${process.env.VUE_APP_WIDGET_IFRAME_URL}/iframe/style.css">
                    <iframe allowfullscreen src="${process.env.VUE_APP_WIDGET_IFRAME_URL}/?bot_id=${this.botId}&&botterLang=${this.selectedLang}" allow="camera;microphone" class="" id="botter-iframe"></iframe>
                    ${iframeJsFile}
                `
                this.generated_widget_card = true
                setTimeout(function(){
                    document.getElementById('generated_widget_card').scrollIntoView()
                }, 1000);
                this.$store.dispatch('setWidgetSettings', this.widgetParameters[this.selectedLang])
            },
            fillMissingData() {
                if (!this.widgetParameters[this.selectedLang].offLineMessageFontColor) {
                    this.widgetParameters[this.selectedLang].offLineMessageFontColor = '#000'
                }

                if (!this.widgetParameters[this.selectedLang].offLineMessageAppearance) {
                    this.widgetParameters[this.selectedLang].offLineMessageAppearance = 'once'
                }

                if (!this.widgetParameters[this.selectedLang].whatsAppBtnColor) {
                    this.widgetParameters[this.selectedLang].whatsAppBtnColor = '#01AF9C'
                }
                if (!this.widgetParameters[this.selectedLang].webBtnColor) {
                    this.widgetParameters[this.selectedLang].webBtnColor = '#FFC108'
                }
                if (!this.widgetParameters[this.selectedLang].whatsAppBtnImg) {
                    this.widgetParameters[this.selectedLang].whatsAppBtnImg = 'https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/whatsapp.png'
                }
                if (!this.widgetParameters[this.selectedLang].webBtnImg) {
                    this.widgetParameters[this.selectedLang].webBtnImg = 'https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/web.png'
                }
                if (!this.widgetParameters[this.selectedLang].buttonsColor) {
                    this.widgetParameters[this.selectedLang].buttonsColor = this.widgetParameters[this.selectedLang].mainColor
                }
                if (!this.widgetParameters[this.selectedLang].buttonsBackgroundColor) {
                    this.widgetParameters[this.selectedLang].buttonsBackgroundColor = '#fff'
                }
                if (!this.widgetParameters[this.selectedLang].buttonsBorderColor) {
                    this.widgetParameters[this.selectedLang].buttonsBorderColor = this.widgetParameters[this.selectedLang].mainColor
                }
                if (!this.widgetParameters[this.selectedLang].faqsTitle) {
                    this.widgetParameters[this.selectedLang].faqsTitle = 'Find an answer your self'
                }
                if (!this.widgetParameters[this.selectedLang].faqsPlaceholder) {
                    this.widgetParameters[this.selectedLang].faqsPlaceholder = 'Search FAQs'
                }



            }
        },
        computed: {
            botId () {
                return this.$store.state.bot.botId
            },
            widgetUrl () {
                return process.env.VUE_APP_WIDGET_IFRAME_URL
            },
            widgetParametersState() {
                return this.widgetParameters[this.selectedLang]
            }
        },
        watch: {
            widgetParametersState: {
                handler(state){
                    this.$emit('updatePreview', state)
                  let wn = document.getElementById('botter-iframe').contentWindow;
                  wn.postMessage({
                    type: 'reload',
                    value: true
                  }, '*');
                    this.saveWidgetSettings()
                },
                deep: true
            },
            selectedLang() {
                this.fillMissingData()
                this.widgetParameters[this.selectedLang].lang = this.selectedLang
            }
        }
    }
</script>

<style scoped>
    hr {
        border-top: 1px solid #eee;
    }
    label {
        margin-bottom: 10px;
        margin-top: 50px;
        display: block;
        font-size: 14px;
        color: black;
    }
    .publish-input-body {
        padding: 5px 0;
    }
    .card-header {
        padding: 0;
    }
    .card-header h5 {
        padding: 1rem 1.25rem;;
        font-size: 1.2em;
        cursor: pointer;
    }
    .btn-group .btn {
        margin-right: 20px;
        border: 1px solid #e6e6e6;
        position: relative;
        padding: 12px 30px;
        font-size: .75rem;
        font-weight: 400;
        line-height: 1.42857;
        text-decoration: none;
        text-transform: uppercase;
        letter-spacing: 0;
        cursor: pointer;
        background: white;
        border-radius: 0.2rem;
        outline: 0;
        transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        will-change: box-shadow, transform;
    }
    .btn-group .active {
        background: #4F47B6;
        color: white;
        border: 1px solid #4F47B6;
    }
    .btn-solid {
        border-radius: 2px !important;
    }
    .btn-rounded {
        border-radius: 20px 0 20px 20px !important;
    }
    .btn-curvey{
        border-radius: 5px 0 5px 5px !important;
    }
    .btn-publish {
        width: 100%;
        font-size: 20px;
    }
    .generated-widget {
        text-transform: initial;
    }
    .generated-widget p {
        word-break: break-all;
    }


</style>

<style >

    @import url('~vue-swatches/dist/vue-swatches.min.css');
    .vue-swatches__trigger {

        width: 30px !important;
        height: 30px !important;
    }
    .active-switch-inline {
        padding-top: 8px !important;
    }

    .dimmer.dialog {

    }
    .vue-swatches__container:not(.vue-swatches--inline) {
        max-height: 350px !important;
    }

    .vue-swatches__swatch {
        position: relative;
        font-size: 0;
        width: 15px !important;
        height: 15px !important;
         padding: 5px !important;
         margin: 5px !important;
        border: none;
        box-shadow: none !important;
    }
    .vue-swatches__check__wrapper {
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
</style>

<style lang="scss">
    .vue-swatches {
        display: inline-block;
        margin-right: 10px;
    }
    .publish-widget .v-text-field--outline .v-input__control > .v-input__slot {
        background: white !important;
        border: 1px solid #e6e6e6 !important;
    }
    .publish-widget .v-input--selection-controls.v-input .v-label {
        margin-bottom: 0;
        font-size: 14px;
        color: black;
    }
    .widget-code p {
        word-break: break-all;
        border: 1px solid #aaaaaa;
        border-radius: 10px;
        padding: 15px;
    }
    .vue-swatches__trigger {
        border: 1px solid #eee;
    }
    .widget-section {
        margin: 50px 0;
    }
    .vue-swatches__container:not(.vue-swatches--inline) {
        width: 300px;
    }

    .chat-bubbles {
        .v-btn {
            margin-right: 10px;
        }
        .v-btn:not(.v-btn--active) {
            background: white !important;
            color: black !important;
            border:1px solid #e6e6e6 !important;
        }
    }
</style>

